import React from "react"
import { Dropdown } from "react-bootstrap"
import { Tooltip } from "react-tooltip"

import useSectionRetake from "../../../hooks/useSectionRetake"
import { RETAKE_SECTIONS } from "./constants"

// Retake dropdown for the overview (home) page PQ Index card. Only shown once the
// participant has completed the full PQ Index survey. Picking a section initiates a
// section retake and redirects to the questionnaire scoped to that section — the
// shared useSectionRetake flow, also used by the dashboard's SectionRetakeButton.
// The whole control is disabled with a tooltip when the enrolment is not active.
function SectionRetakeDropdown({ baseUrl, enrolment }) {
  const {
    startRetake, inflightSection, busy, isActive
  } = useSectionRetake(baseUrl, enrolment)

  // Derive DOM ids from the enrolment so multiple instances on one page (e.g.
  // more than one overview card) can't produce duplicate, colliding ids.
  const instanceId = enrolment?.id ?? "unknown"
  const disabledTooltipId = `overview-retake-disabled-${instanceId}`
  const toggleId = `pq-index-retake-toggle-${instanceId}`

  if (!isActive) {
    return (
      <>
        <span data-tooltip-id={disabledTooltipId} className="d-inline-block">
          <button
            type="button"
            className="btn btn-sm btn-outline-main"
            disabled
            style={{ pointerEvents: "none" }}>
            Retake
          </button>
        </span>
        <Tooltip className="tooltip" id={disabledTooltipId} place="top">
          <span>Your program is no longer active, so sections can&apos;t be retaken.</span>
        </Tooltip>
      </>
    )
  }

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="outline-main"
        size="sm"
        id={toggleId}
        disabled={busy}>
        {busy ? "Starting…" : "Retake"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Header>Retake just one section</Dropdown.Header>
        {RETAKE_SECTIONS.map(section => (
          <Dropdown.Item
            key={section.key}
            as="button"
            type="button"
            disabled={busy}
            onClick={() => startRetake(section.key)}>
            {section.label}
            {inflightSection === section.key ? " …" : ""}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default SectionRetakeDropdown
